import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { translate } from 'helpers/translateHelper';
import { Switch, GeneralSelect } from 'sharedComponents';
import { formatKpiLabel } from './helpers';
import TrendCommentsModalFieldError from './TrendCommentsModalFieldError';
import { useOutsideClickHandler } from '../../../../AssetDetails/Header/AssetLabels/helpers';

const TrendCommentsModalSignalSelectionSection = ({ formData, errors, handleChange, selectedTrendKPIs, trendKPIsList, showSignalSelector }) => {
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const selectWrapRef = useRef(null);
    useOutsideClickHandler(selectWrapRef, () => setMenuIsOpen(false));
    return (
        <Row className='signal-selection-section'>
            <label>
                {translate('ABB.Powertrain.Frontend.opTrendCommentsModalSignalLabel')}
            </label>
            <div className='all-signals-section'>
                <Col>
                    <div className='comment-switch-btn'>
                        <Switch
                            className='me-2'
                            checked={formData.isAllSignals}
                            onChange={(checked) => handleChange('isAllSignals', checked)}
                        />
                        <span>
                            {translate('ABB.Powertrain.Frontend.opTrendCommentsModalAllSignalsLabel')}
                        </span>
                    </div>
                </Col>
                {showSignalSelector &&
                    <Col>
                        <div ref={selectWrapRef}>
                            <GeneralSelect
                                captureMenuScroll={false}
                                closeMenuOnSelect={false}
                                isMulti={true}
                                className={`signal-filter-dropdown ${errors.selectedSignals ? 'error' : ''}`}
                                options={trendKPIsList?.filter(kpi => selectedTrendKPIs?.includes(kpi.timeseriesKey)) || []}
                                getOptionLabel={(option) => formatKpiLabel(option)}
                                getOptionValue={option => option.timeseriesKey}
                                value={formData.selectedSignals}
                                menuShouldScrollIntoView={false}
                                onChange={(value) => handleChange('selectedSignals', value || [])}
                                isSearchable={false}
                                height={32}
                                placeholder={translate('ABB.Powertrain.Frontend.select')}
                                blurInputOnSelect={false}
                                hideSelectedOptions={false}
                                menuIsOpen={menuIsOpen}
                                onMenuOpen={() => setMenuIsOpen(true)}
                                onMenuClose={() => setMenuIsOpen(false)}
                            />
                        </div>
                        <TrendCommentsModalFieldError message={errors.selectedSignals} withIcon />
                    </Col>
                }
            </div>
        </Row>
    );
};

TrendCommentsModalSignalSelectionSection.propTypes = {
    formData: PropTypes.object,
    errors: PropTypes.object,
    handleChange: PropTypes.func,
    selectedTrendKPIs: PropTypes.array,
    trendKPIsList: PropTypes.array,
    showSignalSelector: PropTypes.bool
};

export default TrendCommentsModalSignalSelectionSection;
